import { AxiosResponse } from 'axios';

// user can send in a file name or it is taken from content-disposition headers
export const downloadFile = (response: AxiosResponse, altFileName?: string, altFileType?: string) => {
	const fileType = altFileType ? altFileType : response.headers['content-type'];
	const fileName = altFileName ? altFileName : createFile(response);
	const blob = new Blob([response.data], { type: fileType });
	const url = window.URL.createObjectURL(blob);

	const link = document.createElement('a');

	link.href = url;
	link.setAttribute('download', fileName);
	document.body.appendChild(link);
	link.click();

	setTimeout(() => {
		link?.remove();
	}, 3000);
};

// Axios response will always be sent
function createFile(response: AxiosResponse): string {
	const fileName = response.headers['content-disposition'].split(`filename=`);
	return `${fileName[1]}`;
}

export default downloadFile;
